<template>
    <div name="ListSearch">
        <!-- 搜索条件的 form表单 -->
        <el-form :inline="true" :model="toHtSearchData" label-suffix=":" size="small" label-width="100px">
            <el-row type="flex" style="flex-wrap:wrap;" >
                <el-col v-for="(searchSetOne,index) in searchSetArr" :key="index" 
                    :xs="24" :sm="24" :md="12" :lg="6" :xl="6"
                >
                    <el-form-item :label="searchSetOne.fieldCnName" >
                        <!-- fieldType == 1 则为数字或者弹出层搜索 -->
                        <!-- <div v-if="searchSetOne.fieldType == 1 && searchSetOne.tcPageId > 0" >
                            弹出层搜索 chooseType(0：弹出层  2:下拉框) 

                        </div>-->
                        <div v-if="searchSetOne.fieldType == 1 && searchSetOne.chooseType != 2" >
                            <!-- 数字类型搜索 -->
                            <!-- <el-input v-model="toHtSearchData[searchSetOne.fieldAliasName+'_1_andOr']" style="display: none;" ></el-input> -->
                            <el-col :span="minSpan" v-if="ifIncludeSearch==0">
                                <!-- 默认为大于等于 -->
                                <el-select v-model="toHtSearchData[searchSetOne.fieldAliasName+'_numCondOne_pld']"
                                    class="search_form_input_four"
                                >
                                    <el-option
                                        v-for="dicItem in searchSelectRugual.minNumber"
                                        :key="dicItem.DIC_ID"
                                        :label="dicItem.DIC_NAME"
                                        :value="dicItem.DIC_ID">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="minSpan">
                                <el-input v-model="toHtSearchData[searchSetOne.fieldAliasName+'_numValOne_pld']"
                                    class="search_form_input_four"
                                    @keyup.enter.native="searchData"
                                ></el-input>
                            </el-col>
                            <el-col :span="minSpan" v-if="ifIncludeSearch==0">
                                <el-select v-model="toHtSearchData[searchSetOne.fieldAliasName+'_numCondTwo_pld']" 
                                    class="search_form_input_four"
                                >
                                    <el-option
                                        v-for="dicItem in searchSelectRugual.maxNumber"
                                        :key="dicItem.DIC_ID"
                                        :label="dicItem.DIC_NAME"
                                        :value="dicItem.DIC_ID">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="minSpan">
                                <el-input v-model="toHtSearchData[searchSetOne.fieldAliasName+'_numValTwo_pld']"
                                    class="search_form_input_four"
                                    @keyup.enter.native="searchData"
                                ></el-input>
                            </el-col>
                        </div>
                        <!-- fieldType == 2 则为字符搜索条件 --> 
                        <div v-else-if="searchSetOne.fieldType == 2">
                            <!-- <el-input v-model="toHtSearchData[searchSetOne.fieldAliasName+'_2_andOr']" style="display: none;" ></el-input> -->
                            <el-col :span="minSpan*2" v-if="ifIncludeSearch==0">
                                <el-select v-model="toHtSearchData[searchSetOne.fieldAliasName+'_strCond_pld']" 
                                    class="search_form_input_two"
                                >
                                    <el-option
                                        v-for="dicItem in searchSelectRugual.stringSelect"
                                        :key="dicItem.DIC_ID"
                                        :label="dicItem.DIC_NAME"
                                        :value="dicItem.DIC_ID">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="minSpan*2">
                                <el-input v-model="toHtSearchData[searchSetOne.fieldAliasName+'_strVal_pld']" 
                                    class="search_form_input_two"
                                    @keyup.enter.native="searchData"
                                ></el-input>
                            </el-col>
                        </div>
                        <!-- fieldType == 3 则为日期搜索条件 -->
                        <div v-else-if="searchSetOne.fieldType == 3" >
                            <!-- <el-input v-model="toHtSearchData[searchSetOne.fieldAliasName+'_3_andOr']" style="display: none;" ></el-input> -->
                            <!-- <el-input v-model="toHtSearchData[searchSetOne.fieldAliasName+'_dateType']" style="display: none;" ></el-input> -->
                            <el-col :span="12">
                                <el-date-picker size="mini" style="width:100px;" :title="toHtSearchData[searchSetOne.fieldAliasName+'_startDates_pld']"
                                    v-model="toHtSearchData[searchSetOne.fieldAliasName+'_startDates_pld']"
                                    placeholder="开始"
                                    :type="toHtSearchData[searchSetOne.fieldAliasName+'_type']"
                                    :format="toHtSearchData[searchSetOne.fieldAliasName+'_dateType']"
                                    :value-format="toHtSearchData[searchSetOne.fieldAliasName+'_dateType']"
                                    @change="dateChange(searchSetOne)"
                                    class="search_form_input_two"
                                >
                                </el-date-picker>
                            </el-col>
                            <el-col :span="12">
                                <el-date-picker size="mini" style="width:100px;" :title="toHtSearchData[searchSetOne.fieldAliasName+'_endDates_pld']"
                                    v-model="toHtSearchData[searchSetOne.fieldAliasName+'_endDates_pld']"
                                    placeholder="结束"
                                    :type="toHtSearchData[searchSetOne.fieldAliasName+'_type']"
                                    :format="toHtSearchData[searchSetOne.fieldAliasName+'_dateType']"
                                    :value-format="toHtSearchData[searchSetOne.fieldAliasName+'_dateType']"
                                    @change="dateChange(searchSetOne)"
                                    class="search_form_input_two"
                                >   
                                </el-date-picker>
                            </el-col>
                        </div>
                        <!-- fieldType == 4 则为下拉框搜索条件  -->
                        <div v-else-if="searchSetOne.fieldType == 4 || (searchSetOne.fieldType == 1 && searchSetOne.chooseType == 2)">
                            <!-- <el-input v-model="toHtSearchData[searchSetOne.fieldAliasName+'_d_andOr']" style="display: none;" ></el-input> -->
                            <el-col :span="minSpan*2" v-if="ifIncludeSearch==0">
                                <el-select v-model="toHtSearchData[searchSetOne.fieldAliasName+'_d_dicCond_pld']" 
                                    class="search_form_input_two"
                                >
                                    <el-option
                                        v-for="dicItem in searchSelectRugual.dicSelect"
                                        :key="dicItem.DIC_ID"
                                        :label="dicItem.DIC_NAME"
                                        :value="dicItem.DIC_ID">
                                    </el-option>
                                </el-select>
                            </el-col>
                            <el-col :span="minSpan*2">
                                <el-select v-model="toHtSearchData[searchSetOne.fieldAliasName+'strCond_dic']" multiple 
                                    class="search_form_input_two"
                                >
                                    <el-option
                                        v-for="dicItem in searchSetOne.dicList"
                                        :key="dicItem.DIC_ID"
                                        :label="dicItem.DIC_NAME"
                                        :value="dicItem.DIC_ID">
                                    </el-option>
                                </el-select>
                            </el-col>
                        </div> 
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- 是否支持空闲时段筛选功能，如果支持则进行搜索条件的显示-->
            <el-form-item v-if="ifFreeTimeSearch == 1">
                <el-button type="primary" @click="addFreeTimeSearch">新增</el-button>
            </el-form-item> 
            <div v-if="ifFreeTimeSearch == 1" >
                <div v-for="(freeTimeSearchOne,freeIndex) in toHtSearchData.freeTimeSearchArr" :key="'free_'+freeIndex"  >
                    <el-input v-model="freeTimeSearchOne.freeTime_6_andOr" style="display: none;" ></el-input>
                    <el-form-item label="日期范围">
                        <el-col :span="12">
                            <el-date-picker
                                v-model="freeTimeSearchOne.startDate_startDates_pld"
                                placeholder="开始日期"
                                type="date"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                >
                            </el-date-picker>
                        </el-col>
                        <el-col :span="12">
                            <el-date-picker
                                v-model="freeTimeSearchOne.endDate_endDates_pld"
                                placeholder="结束日期"
                                type="date"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                >   
                            </el-date-picker>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="时间范围">
                        <el-col :span="12">
                            <el-date-picker
                                v-model="freeTimeSearchOne.startTime_startDates_pld"
                                placeholder="开始时段"
                                type="time"
                                format="HH:mm"
                                value-format="HH:mm"
                                >
                            </el-date-picker>
                        </el-col>
                        <el-col :span="12">
                            <el-date-picker
                                v-model="freeTimeSearchOne.endTime_endDates_pld"
                                placeholder="结束时段"
                                type="time"
                                format="HH:mm"
                                value-format="HH:mm"
                                >   
                            </el-date-picker>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="星期范围">
                        <el-col :span="12">
                            <el-select v-model="freeTimeSearchOne.startWeek_startDates_pld" >
                                <el-option
                                    v-for="dicItem in searchSelectRugual.weekSelect"
                                    :key="dicItem.DIC_ID"
                                    :label="dicItem.DIC_NAME"
                                    :value="dicItem.DIC_ID">
                                </el-option>
                            </el-select>
                        </el-col>
                        <el-col :span="12">
                            <el-select v-model="freeTimeSearchOne.endWeek_startDates_pld" >
                                <el-option
                                    v-for="dicItem in searchSelectRugual.weekSelect"
                                    :key="dicItem.DIC_ID"
                                    :label="dicItem.DIC_NAME"
                                    :value="dicItem.DIC_ID">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-form-item>
                </div>
            </div>
            <!--<el-form-item>
                <el-button type="primary" @click="initSearchData">查询</el-button>
            </el-form-item>-->
        </el-form>
    </div>
</template>

<script>
import utils from '@/js/page/pageUtil.js'

export default {
  name: 'ListSearch',
  props: {
    searchSetArr: Array,
    //是否显示 下拉框进行搜索方式切换  0:显示 1:不显示
    ifIncludeSearch:{
        type:Number,
        default:0
    },
    ifFreeTimeSearch: Number
  },
  beforeMount: function(){
    if(this.ifIncludeSearch == 1) {
        this.minSpan = 12;
    }
    console.log("minSpan====================================",this.ifIncludeSearch,this.minSpan);
  },
  methods:{
    /**
     * 调用搜索功能
     */
    searchData(){
        this.$emit("initSearchData");
    },
    /**
     * 日期切换时 进行选中
     */
    dateChange(searchSetOne){
        var toHtSearchData = this.toHtSearchData;
        var startDate = toHtSearchData[searchSetOne.fieldAliasName+'_startDates_pld'];
        var endDate = toHtSearchData[searchSetOne.fieldAliasName+'_endDates_pld'];
        if(endDate == null || endDate == "" || endDate < startDate) {
            toHtSearchData[searchSetOne.fieldAliasName+'_endDates_pld'] = startDate;
        }
        if(startDate == null ||  startDate == "") {
            toHtSearchData[searchSetOne.fieldAliasName+'_startDates_pld'] = endDate;
        }
    },

    /**
     * 支持空闲时段搜索时 点击新增增加一条空闲时段搜索记录
    */
    addFreeTimeSearch() {
        var toHtSearchData = this.toHtSearchData;
        var freeTimeSearchArr = this.toHtSearchData.freeTimeSearchArr;
        var jsonStr = JSON.stringify(freeTimeSearchArr[0]);
        var tmpJson = JSON.parse(jsonStr);
        freeTimeSearchArr.push(tmpJson);
        toHtSearchData.freeTimeSearchArr = freeTimeSearchArr;

        this.toHtSearchData = toHtSearchData;
    }
  },
  data(){
      return{
        //搜索条件的内部宽度
        minSpan:6,
        //搜索条件需要传递到后台的数据信息
        toHtSearchData:{
        },
          //搜索条件下拉框的数据字典值
        searchSelectRugual:{
            minNumber:[{
                DIC_ID : 2,
                DIC_NAME : '等于'
            },{
                DIC_ID : 0,
                DIC_NAME : '大于'
            },{
                DIC_ID : 1,
                DIC_NAME : '大于等于'
            },{
                DIC_ID : 3,
                DIC_NAME : '为空'
            },{
                DIC_ID : 4,
                DIC_NAME : '不为空'
            }],
            maxNumber:[{
                DIC_ID : 2,
                DIC_NAME : '等于'
            },{
                DIC_ID : 0,
                DIC_NAME : '小于'
            },{
                DIC_ID : 1,
                DIC_NAME : '小于等于'
            },{
                DIC_ID : 3,
                DIC_NAME : '为空'
            },{
                DIC_ID : 4,
                DIC_NAME : '不为空'
            }],
            stringSelect:[{
                DIC_ID : 0,
                DIC_NAME : '包含'
            },{
                DIC_ID : 3,
                DIC_NAME : '起始字符'
            },{
                DIC_ID : 2,
                DIC_NAME : '等于'
            },{
                DIC_ID : 1,
                DIC_NAME : '不包含'
            },{
                DIC_ID : 5,
                DIC_NAME : '为空'
            },{
                DIC_ID : 7,
                DIC_NAME : '不为空'
            },{
                DIC_ID : 6,
                DIC_NAME : '全局等于'
            }],
            dicSelect:[{
                DIC_ID : 0,
                DIC_NAME : '包含'
            },{
                DIC_ID : 1,
                DIC_NAME : '不包含'
            }],
            weekSelect:[{
                DIC_ID : -1,
                DIC_NAME : '请选择'
            },{
                DIC_ID : 1,
                DIC_NAME : '星期一'
            },{
                DIC_ID : 2,
                DIC_NAME : '星期二'
            },{
                DIC_ID : 3,
                DIC_NAME : '星期三'
            },{
                DIC_ID : 4,
                DIC_NAME : '星期四'
            },{
                DIC_ID : 5,
                DIC_NAME : '星期五'
            },{
                DIC_ID : 6,
                DIC_NAME : '星期六'
            },{
                DIC_ID : 7,
                DIC_NAME : '星期日'
            }]
        }
      }
  }
}
</script>

<style scoped>
/* 搜索条件有两个框的宽度样式 */
.search_form_input_two{
    width: 130px
}
/* 搜索条件有四个框的宽度样式 */
.search_form_input_four{
    width: 70px
}
</style>
